import CookiePolicy from '@/views/CookiePolicy/index.vue';

export default [
  {
    path: '/cookie-policy',
    name: 'CookiePolicy',
    component: CookiePolicy,
    meta: {
      titleType: 'cookiePolicy',
    },
  },
];
